var map = {
	"./3Crv-logo.png": 951,
	"./BAC-DAI UNI V2-logo.png": 952,
	"./BAC-DAI UNI-V2-logo.png": 953,
	"./BT-logo.png": 204,
	"./BTU-BT UNI-V2-logo.png": 954,
	"./BTU-logo.png": 955,
	"./DAI-ETH SLP-logo.png": 956,
	"./DAI-logo.png": 957,
	"./ETH-logo.png": 958,
	"./SUSHI-ETH SLP-logo.png": 959,
	"./UNI-logo.png": 960,
	"./USDC-ETH SLP-logo.png": 961,
	"./USDC-logo.png": 962,
	"./USDT-ETH SLP-logo.png": 963,
	"./USDT-logo.png": 964,
	"./WBTC-ETH SLP-logo.png": 965,
	"./WBTC-logo.png": 966,
	"./WETH-logo.png": 967,
	"./alUSD3CRV-logo.png": 968,
	"./b3Crv-logo.png": 969,
	"./bBAC-DAI UNI V2-logo.png": 970,
	"./bBAC-DAI UNI-V2-logo.png": 971,
	"./bDAI-ETH SLP-logo.png": 972,
	"./bDAI-logo.png": 973,
	"./bETH-logo.png": 974,
	"./bSUSHI-ETH SLP-logo.png": 975,
	"./bUNI-logo.png": 976,
	"./bUSDC-ETH SLP-logo.png": 977,
	"./bUSDC-logo.png": 978,
	"./bUSDT-ETH SLP-logo.png": 979,
	"./bUSDT-logo.png": 980,
	"./bWBTC-ETH SLP-logo.png": 981,
	"./bWBTC-logo.png": 982,
	"./bWETH-logo.png": 983,
	"./balUSD3CRV-logo.png": 984,
	"./bcrvRenWBTC-logo.png": 985,
	"./crvRenWBTC-logo.png": 986,
	"./images/3Crv-logo.png": 987,
	"./images/BAC-DAI UNI V2-logo.png": 988,
	"./images/BAC-DAI UNI-V2-logo.png": 989,
	"./images/BT-logo.png": 990,
	"./images/BTU-BT UNI-V2-logo.png": 991,
	"./images/BTU-logo.png": 992,
	"./images/DAI-ETH SLP-logo.png": 993,
	"./images/DAI-logo.png": 994,
	"./images/ETH-logo.png": 995,
	"./images/SUSHI-ETH SLP-logo.png": 996,
	"./images/UNI-logo.png": 997,
	"./images/USDC-ETH SLP-logo.png": 998,
	"./images/USDC-logo.png": 999,
	"./images/USDT-ETH SLP-logo.png": 1000,
	"./images/USDT-logo.png": 1001,
	"./images/WBTC-ETH SLP-logo.png": 1002,
	"./images/WBTC-logo.png": 1003,
	"./images/WETH-logo.png": 1004,
	"./images/b3Crv-logo.png": 1005,
	"./images/bBAC-DAI UNI V2-logo.png": 1006,
	"./images/bBAC-DAI UNI-V2-logo.png": 1007,
	"./images/bDAI-ETH SLP-logo.png": 1008,
	"./images/bDAI-logo.png": 1009,
	"./images/bETH-logo.png": 1010,
	"./images/bSUSHI-ETH SLP-logo.png": 1011,
	"./images/bUNI-logo.png": 1012,
	"./images/bUSDC-ETH SLP-logo.png": 1013,
	"./images/bUSDC-logo.png": 1014,
	"./images/bUSDT-ETH SLP-logo.png": 1015,
	"./images/bUSDT-logo.png": 1016,
	"./images/bWBTC-ETH SLP-logo.png": 1017,
	"./images/bWBTC-logo.png": 1018,
	"./images/bWETH-logo.png": 1019,
	"./images/bcrvRenWBTC-logo.png": 1020,
	"./images/crvRenWBTC-logo.png": 1021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;